import { useQuery } from '@tanstack/react-query';
import { CapTablesService, type WaterfallInvestedCapitalResponse } from 'api';

const WATERFALL_INVESTED_CAPITAL_QUERY_KEY = 'waterfall-invested-capital';

interface UseWaterfallInvestedCapitalParams {
  capTableId?: number;
  enabled: boolean;
  targetCurrency: string;
}

export const useWaterfallInvestedCapital = ({
  capTableId,
  enabled,
  targetCurrency,
}: UseWaterfallInvestedCapitalParams) =>
  useQuery<WaterfallInvestedCapitalResponse, Error>({
    enabled: enabled && capTableId != null,
    meta: { showGlobalError: false },
    queryFn: () => CapTablesService.apiCapTablesWaterfallInvestedCapitalRead(capTableId as number, targetCurrency),
    queryKey: [WATERFALL_INVESTED_CAPITAL_QUERY_KEY, capTableId, targetCurrency],
  });
